import { z } from 'zod';
import { c } from '../contract';

const progressUpdatesSchema = z.object({
  episodeId: z.number().optional(),
  maxUnlockedEpisodeId: z.number().optional(),
  completedAtChapterCnt: z.number().optional(),
  isInLibrary: z.boolean().optional(),
  isCountdownReached: z.boolean().optional(),
  contentId: z.number().nullable().optional(),
  contentDataId: z.number().nullable().optional(),
  scrollPosition: z.number().nullable().optional(),
});

export const progressRouter = c.router(
  {
    update: {
      summary: 'Update reading progress for a story',
      method: 'POST',
      path: '/update',
      body: z.object({
        storySlug: z.string(),
        progressUpdates: progressUpdatesSchema,
      }),
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
        400: z.object({
          error: z.string(),
        }),
        500: z.object({
          error: z.string(),
        }),
      },
    },
    unlockEpisode: {
      summary: 'Unlock an episode using points or subscription',
      method: 'POST',
      path: '/unlock-episode',
      body: z.object({
        storyId: z.string(),
        chapterNumber: z.number(),
        isForced: z.boolean().default(false),
        locale: z.string(),
        pointsAmount: z.number().optional(), // Dynamic unlock cost
        waitTimeMinutes: z.number().optional(), // Dynamic wait time
      }),
      responses: {
        200: z.object({
          success: z.boolean(),
          user_points: z.number().optional(),
          message: z.string().optional(),
          next_unlock_ts: z.number().optional(),
        }),
        400: z.object({
          error: z.string(),
        }),
        500: z.object({
          error: z.string(),
        }),
      },
    },
  },
  { pathPrefix: '/progress' },
);
